import React from 'react';
import Icon from '../../../components/AppIcon';


const RegistrationHeader = ({ currentLanguage, onLanguageChange }) => {
  const content = {
    fr: {
      title: 'Inscription Agence',
      subtitle: 'Créez votre compte pour gérer vos pèlerinages Omra & Hajj',
      loginPrompt: 'Vous avez déjà un compte ?',
      loginLink: 'Se connecter'
    },
    ar: {
      title: 'تسجيل الوكالة',
      subtitle: 'أنشئ حسابك لإدارة رحلات العمرة والحج',
      loginPrompt: 'هل لديك حساب بالفعل؟',
      loginLink: 'تسجيل الدخول'
    }
  };

  const text = content?.[currentLanguage];

  return (
    <div className="bg-card border-b border-border shadow-warm">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-4 md:py-6">
        <div className="flex items-center justify-between flex-wrap gap-4">
          <div className="flex items-center gap-3 md:gap-4">
            <div className="w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 rounded-xl bg-primary/10 flex items-center justify-center">
              <Icon name="Compass" size={24} className="text-primary md:w-7 md:h-7 lg:w-8 lg:h-8" />
            </div>
            <div>
              <h1 className="text-xl md:text-2xl lg:text-3xl font-semibold text-foreground">
                {text?.title}
              </h1>
              <p className="caption text-muted-foreground mt-1 hidden sm:block">
                {text?.subtitle}
              </p>
            </div>
          </div>

          <div className="flex items-center gap-3 md:gap-4">
            <button
              onClick={onLanguageChange}
              className="flex items-center gap-2 px-3 md:px-4 py-2 rounded-md bg-muted hover:bg-muted/80 transition-smooth"
              aria-label="Change language"
            >
              <Icon name="Languages" size={18} className="text-muted-foreground" />
              <span className="text-sm font-medium text-foreground">
                {currentLanguage === 'fr' ? 'العربية' : 'Français'}
              </span>
            </button>

            <a
              href="/login"
              className="flex items-center gap-2 px-3 md:px-4 py-2 rounded-md bg-primary text-primary-foreground hover:bg-primary/90 transition-smooth shadow-warm hover:shadow-warm-md"
            >
              <span className="text-sm font-medium hidden sm:inline">
                {text?.loginPrompt}
              </span>
              <span className="text-sm font-medium">{text?.loginLink}</span>
              <Icon name="ArrowRight" size={16} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrationHeader;